import Settings from "@/features/users/settings/index.jsx";

const UserSettings = () => {
  return <Settings />;
};

export default UserSettings;
